import ArgoIcon from '../../images/argocd.svg';
import ArgoMonoIcon from '../../images/argocd-mono.svg';
import ArgoProjectIcon from '../../images/argocd-project.svg';
import ArgoApplicationIcon from '../../images/argocd-application.svg';
import ArgoApplicationSetIcon from '../../images/argocd-application-set.svg';
import HelmLogo from '../../images/helm.svg';
import KubernetesLogo from '../../images/kubernetes.svg';

const ICON_SIZES = {
  small: 18,
  medium: 24,
  large: 32,
} as const;

export type IconSize = keyof typeof ICON_SIZES;

export interface IconProps {
  size?: IconSize;
  alt?: string;
}

export const KubernetesIcon = ({ size = 'medium', alt }: IconProps) => (
  <img
    height={ICON_SIZES[size]}
    src={KubernetesLogo}
    alt={alt ?? 'Kubernetes icon'}
  />
);

export const HelmIcon = ({ size = 'medium', alt }: IconProps) => (
  <img height={ICON_SIZES[size]} src={HelmLogo} alt={alt ?? 'Helm'} />
);

export const ArgoCDIcon = ({ size = 'medium', alt }: IconProps) => (
  <img height={ICON_SIZES[size]} src={ArgoIcon} alt={alt ?? 'ArgoCD'} />
);

interface MonoIconProps {
  src: string;
  size: IconSize;
  alt: string;
}

const MonoIcon = ({ src, size, alt }: MonoIconProps) => {
  const px = ICON_SIZES[size];
  return (
    <span
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: px,
        height: px,
        backgroundColor: 'currentColor',
        mask: `url("${src}") center / contain no-repeat`,
      }}
    />
  );
};

export const ArgoCDMonoIcon = ({ size = 'medium', alt }: IconProps) => (
  <MonoIcon src={ArgoMonoIcon} size={size} alt={alt ?? 'ArgoCD'} />
);

export const ArgoCDProjectIcon = ({ size = 'medium', alt }: IconProps) => (
  <MonoIcon src={ArgoProjectIcon} size={size} alt={alt ?? 'ArgoCD Project'} />
);

export const ArgoCDApplicationIcon = ({ size = 'medium', alt }: IconProps) => (
  <MonoIcon
    src={ArgoApplicationIcon}
    size={size}
    alt={alt ?? 'ArgoCD Application'}
  />
);

export const ArgoCDApplicationSetIcon = ({
  size = 'medium',
  alt,
}: IconProps) => (
  <MonoIcon
    src={ArgoApplicationSetIcon}
    size={size}
    alt={alt ?? 'ArgoCD Application Set'}
  />
);
